"use client";

import React from "react";
import { motion } from "framer-motion";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell, TableCaption } from "@/components/ui/table";
import { Card, CardContent } from "@/components/ui/card";
const tableOneData = [{
  metric: "Population (July 1, 2025 estimate)",
  value: "25,276"
}, {
  metric: "Median value of owner-occupied homes (2020-2024)",
  value: "$701,400"
}, {
  metric: "Owner-occupied housing rate (2020-2024)",
  value: "63.9%"
}, {
  metric: "Median household income (2020-2024, 2024 dollars)",
  value: "$139,397"
}, {
  metric: "Persons per household",
  value: "2.49"
}];
const tableTwoData = [{
  metric: "Projected homeowner improvement spending by end of 2026",
  value: "$518 billion"
}];
export default function MarketOverview() {
  return <section id="decaturmarketoverview" data-nav="light" className="relative bg-background text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* Table 1 Card */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          ease: [0.16, 1, 0.3, 1],
          delay: 0
        }} whileHover={{
          y: -4
        }} className="lg:col-span-7">
            <Card className="bg-card/85 backdrop-blur-md border border-border rounded-xl shadow-sm hover:border-ring/40 transition-colors duration-300 p-6 sm:p-8">
              <CardContent className="p-0 space-y-4">
                <div className="relative w-full overflow-x-auto rounded-lg">
                  <Table className="w-full text-left border-collapse">
                    <TableCaption className="text-left font-serif text-2xl font-semibold text-foreground mb-4 caption-top">
                      Decatur at a Glance
                    </TableCaption>
                    <TableHeader className="bg-muted/40">
                      <TableRow className="border-b border-border">
                        <TableHead className="font-semibold text-foreground py-3.5 px-4">
                          Metric
                        </TableHead>
                        <TableHead className="font-semibold text-foreground py-3.5 px-4 text-right">
                          Value
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {tableOneData.map((row, i) => <TableRow key={row.metric} data-index={i} className="border-b border-border/70 hover:bg-muted/30 transition-colors">
                          <TableCell className="py-3.5 px-4 text-foreground/90 font-medium whitespace-normal sm:whitespace-nowrap">
                            {row.metric}
                          </TableCell>
                          <TableCell className="py-3.5 px-4 text-foreground font-semibold text-right whitespace-nowrap">
                            {row.value}
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
                <div className="pt-2">
                  <p className="text-xs text-muted-foreground">
                    Source: U.S. Census Bureau, QuickFacts
                  </p>
                </div>
              </CardContent>
            </Card>
          </motion.div>

          {/* Table 2 Card */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          ease: [0.16, 1, 0.3, 1],
          delay: 0.08
        }} whileHover={{
          y: -4
        }} className="lg:col-span-5">
            <Card className="bg-card/85 backdrop-blur-md border border-border rounded-xl shadow-sm hover:border-ring/40 transition-colors duration-300 p-6 sm:p-8">
              <CardContent className="p-0 space-y-4">
                <div className="relative w-full overflow-x-auto rounded-lg">
                  <Table className="w-full text-left border-collapse">
                    <TableCaption className="text-left font-serif text-2xl font-semibold text-foreground mb-4 caption-top">
                      U.S. Remodeling Outlook
                    </TableCaption>
                    <TableHeader className="bg-muted/40">
                      <TableRow className="border-b border-border">
                        <TableHead className="font-semibold text-foreground py-3.5 px-4">
                          Metric
                        </TableHead>
                        <TableHead className="font-semibold text-foreground py-3.5 px-4 text-right">
                          Value
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {tableTwoData.map((row, i) => <TableRow key={row.metric} data-index={i} className="border-b border-border/70 hover:bg-muted/30 transition-colors">
                          <TableCell className="py-3.5 px-4 text-foreground/90 font-medium whitespace-normal sm:whitespace-nowrap">
                            {row.metric}
                          </TableCell>
                          <TableCell className="py-3.5 px-4 text-foreground font-semibold text-right whitespace-nowrap">
                            {row.value}
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
                <div className="pt-2">
                  <p className="text-xs text-muted-foreground leading-relaxed">
                    Source: Harvard Joint Center for Housing Studies, Leading
                    Indicator of Remodeling Activity (LIRA), April 2026
                  </p>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>;
}